import axios from 'axios'

import Config from '../config'

export async function getPrivacy (locale) {
	const response = await axios.get(Config.url + '/api/pages/privacy', {
		params: {
			locale
		}
	})
	return response.data
}

export async function getTerms (locale) {
	const response = await axios.get(Config.url + '/api/pages/terms', {
		params: {
			locale
		}
	})
	return response.data
}

export async function getWarnings (locale) {
	const response = await axios.get(Config.url + '/api/pages/warnings', {
		params: {
			locale
		}
	})
	return response.data
}

export async function submitCode (code) {
	const response = await axios.post(Config.url + '/api/auth/company-code', {
		code,
		'client' : Config.auth.client,
		'company': true
	})
	return response.data
}

export async function submitPasswordRecover (token, email) {
	const response = await axios.post(Config.url + '/api/auth/web-password-recover', { token, email })
	return response.data
}

export async function submitSignup (token, data) {
	const response = await axios.post(Config.url + '/api/auth/web-signup', {
		token,
		...data
	})
	return response.data
}

export async function submitPasswordRecoverConfirm (token, code) {
	const response = await axios.post(Config.url + '/api/auth/web-password-recover/confirm', {
		token,
		code
	})
	return response.data
}

export async function submitSignupConfirm (token, code) {
	const response = await axios.post(Config.url + '/api/auth/web-signup/confirm', {
		token,
		code
	})
	return response.data
}

export async function verifyEmail (token, email, password) {
	const response = await axios.post(Config.url + '/api/auth/web-signup/verify-email', {
		client: Config.auth.client,
		token,
		email,
		password
	})
	return response.data
}

export async function getLoginToken () {
	const response = await axios.get(Config.url + '/api/auth/web-login', {
		params: {
			client: Config.auth.client
		}
	})
	return response.data
}

export async function getPasswordToken () {
	const response = await axios.get(Config.url + '/api/auth/web-password-recover', {
		params: {
			client: Config.auth.client
		}
	})
	return response.data
}

export async function getSignupToken () {
	const response = await axios.get(Config.url + '/api/auth/web-signup', {
		params: {
			client: Config.auth.client
		}
	})
	return response.data
}

export async function submitLogin (token, email, password) {
	const response = await axios.post(Config.url + '/api/auth/web-login', {
		token,
		email,
		password
	})
	return response.data
}

export async function submitLogout (token) {
	const response = await axios({
		method : 'delete',
		url    : Config.url + '/api/auth/web-logout',
		headers: { Authorization: `Bearer ${token}` }
	})
	return response.data
}

export async function submitPassword ({ account_user, restore_password, password, new_password, confirm_password }, token) {
	if (restore_password && new_password && confirm_password) {
		const response = await axios({
			method : 'post',
			url    : account_user ? (Config.url + '/api/auth/web-user-restore-password') : (Config.url + '/api/auth/web-restore-password'),
			headers: { Authorization: `Bearer ${token}` },
			data   : {
				restore_password,
				new_password,
				confirm_password
			}
		})
		return response.data
	}

	if (password && new_password && confirm_password) {
		const response = await axios({
			method : 'post',
			url    : account_user ? (Config.url + '/api/auth/web-user-password') : (Config.url + '/api/auth/web-password'),
			headers: { Authorization: `Bearer ${token}` },
			data   : {
				password,
				new_password,
				confirm_password
			}
		})
		return response.data
	}

	return null
}

export async function getUserState (token) {
	const response = await axios({
		method : 'get',
		url    : Config.url + '/api/user/web-account-status',
		headers: { Authorization: `Bearer ${token}` }
	})
	return response.data
}

export async function getUserProfile (token) {
	const response = await axios({
		method : 'get',
		url    : Config.url + '/api/user/web-account-profile',
		headers: { Authorization: `Bearer ${token}` }
	})
	return response.data
}

export async function getUserCustomer (token) {
	const response = await axios({
		method : 'get',
		url    : Config.url + '/api/user/web-account-customer',
		headers: { Authorization: `Bearer ${token}` }
	})
	return response.data
}

export async function postSubscriptionSubmitted (token, { customer, subscription }, intent, invoice) {
	const response = await axios({
		method : 'post',
		url    : Config.url + '/api/user/web-submit-subscription',
		headers: { Authorization: `Bearer ${token}` },
		data   : {
			customer,
			subscription,
			intent,
			invoice
		}
	})
	return response.data
}

export async function getUserQrcode (token) {
	const response = await axios({
		method : 'get',
		url    : Config.url + '/api/auth/web-login/qrcode',
		headers: { Authorization: `Bearer ${token}` }
	})
	return response.data
}

export async function checkPromoCode ({ code }) {
	const response = await axios({
		method: 'post',
		url   : Config.url + '/api/web-promo-code',
		data  : {
			'client': Config.auth.client,
			'code'  : code
		}
	})
	return response.data
}

export async function submitPromoCode ({ token, code }) {
	const response = await axios({
		method: 'post',
		url   : Config.url + '/api/user/web-promo-code',
		data  : {
			'code': code
		},
		headers: { Authorization: `Bearer ${token}` }
	})
	return response.data
}

export async function getCodes (token) {
	const response = await axios({
		method : 'get',
		url    : Config.url + '/api/company/codes',
		headers: { Authorization: `Bearer ${token}` }
	})
	return response.data
}

export async function getTickets (token) {
	const response = await axios({
		method : 'get',
		url    : Config.url + '/api/company/tickets',
		headers: { Authorization: `Bearer ${token}` }
	})
	return response.data
}

export async function submitTicket ({ token, subject, message }) {
	const response = await axios({
		method: 'post',
		url   : Config.url + '/api/company/ticket',
		data  : {
			'subject': subject,
			'message': message
		},
		headers: { Authorization: `Bearer ${token}` }
	})
	return response.data
}

export async function submitRequest ({ name, mobile }) {
	const response = await axios({
		method: 'post',
		url   : Config.url + '/api/contact-request',
		data  : {
			'client': Config.auth.client,
			'name'  : name,
			'mobile': mobile
		}
	})
	return response.data
}

export async function getRanks (token, month) {
	const response = await axios({
		method : 'get',
		url    : month ? Config.url + '/api/company/ranks/month' : Config.url + '/api/company/ranks/general',
		headers: { Authorization: `Bearer ${token}` }
	})
	return response.data
}

export async function getFrequencyStats(url, token, start, end) {
	const response = await axios({
		method: 'get',
		url   : Config.url + '/api/video-freq/' + url,
		params: {
			'start': start,
			'end'  : end
		},
		headers: { Authorization: `Bearer ${token}` }
	})
	return response.data
}
